import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ConversationModel, FullUserProfileModel } from "types";
import { ConversationService, SharedService } from "../../core";

@Component({
  selector: "app-conversation-list",
  templateUrl: "./conversation-list.component.html",
  styleUrls: ["./conversation-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConversationListComponent implements OnInit, OnDestroy {
  @Input() public conversations: ConversationModel[] | null = null;
  @Input() public userAccount: FullUserProfileModel | null = null;
  @Input() public canLoadMore = false;
  @Input() public loading = false;
  @Input() public routePrefixes: string[] = [];
  @Input() public overrideUrl: string | null = null;
  @Input() public isRolesSidenav: boolean = false;
  @Input() public isScribeSidenav: boolean = false;
  @Input() public disableConversationActions: boolean = false;

  @Output() public loadMore = new EventEmitter(); // todo: should emit when we scroll, not button click;
  @Output() public conversationClick = new EventEmitter<ConversationModel>();

  private inboxSubscriber: any;

  public constructor(
    private conversationService: ConversationService,
    private sharedService: SharedService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngOnInit() {
    this.inboxSubscriber = this.conversationService.onInboxSorted.subscribe(
      () => {
        this.changeDetectorRef.detectChanges();
      }
    );
  }

  public ngOnDestroy() {
    if (this.inboxSubscriber) {
      this.inboxSubscriber.unsubscribe();
    }
  }

  public isOnline() {
    return this.sharedService.isOnline();
  }

  public muteStatusChange(participantData, conversation) {
    this.conversationService.updateMuteStatusInConversation(
      participantData.userId,
      conversation.id,
      participantData.mutedToUtc,
      participantData.muteInterval
    );
  }

  public getRouterLink(conversation: ConversationModel) {
    if (this.overrideUrl) {
      return this.overrideUrl.replace(":id", conversation.id);
    }

    return [...this.routePrefixes, conversation.id, "messages"];
  }

  public getQueryParams(conversation: ConversationModel) {
    // if (this.overrideUrl) {
    //   return { id: conversation.id };
    // }

    return null;
  }

  public handleConversationClick(conversation: ConversationModel) {
    this.conversationClick.emit(conversation);
  }
}
